import { Link } from '@tanstack/react-router'
import { SidebarShell, SidebarList, SidebarNavLink, type NavItem } from '@region13/ui'
import { COACH_NAV } from '../lib/nav'

/** The shared platform sidebar with COACH_NAV's nine pages. Desktop (md+) shows
 *  it at the left; below md it is the drawer the bottom bar's More tab opens
 *  (no masthead of its own: the coach Masthead stays the phone header, and
 *  AppShell owns the open state). No admin section (the coach app has a single
 *  `coach:read` tier). */
export function Sidebar({
  email,
  onSignOut,
  drawer,
}: {
  email: string
  onSignOut: () => void
  drawer: { open: boolean; onOpenChange: (open: boolean) => void; returnFocusTo: () => HTMLElement | null }
}) {
  return (
    <SidebarShell
      brand={{
        logoSrc: '/logo.svg',
        subtitle: 'Coach',
        home: (c) => <Link to="/">{c}</Link>,
      }}
      storageKey="r13:coach-sidebar-collapsed"
      identity={email}
      signOut={{ onClick: onSignOut }}
      mobile="drawer"
      masthead={false}
      drawer={drawer}
      build={String(import.meta.env.VITE_BUILD_ID ?? 'dev')}
    >
      <SidebarList>
        {COACH_NAV.items.map((item) => (
          <CoachNavLink key={item.to} item={item} />
        ))}
      </SidebarList>
    </SidebarShell>
  )
}

function CoachNavLink({ item }: { item: NavItem }) {
  return (
    <SidebarNavLink
      icon={item.icon}
      label={item.label}
      render={(p) => <Link to={item.to} activeOptions={{ exact: item.to === '/' }} {...p} />}
    />
  )
}
